
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Loading from 'vux/src/components/loading/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'

import global from '../../../static/js/global'
import loadPage from '../../components/loadingPage'
export default {
components: {
Flexbox,
FlexboxItem,
XImg,
Group,
PopupPicker,
XTextarea,
XButton,
Tab,
TabItem,
Datetime,
Alert,
Loading,
loadPage
},
data(){
return{
sbm:false, // 为false时候 提交不能点击
src:'',
houseonwer:'1592645632(1592645632)',
houseinfo:'',
repairtype:'',
repair:[],
info:'',
perTag:[],
perTagId:[],
perTagName:[],
pubTag:[],
pubTagId:[],
pubTagName:[],
ensureTime:[],
ensureDate:'',
minyear:'',
timelist:[['8:00-8:59','9:00-9:59','10:00-10:59','11:00-11:59','12:00-12:59','13:00-13:59','14:00-14:59','15:00-15:59','16:00-16:59','17:00-17:59']],
showTime:true,
filecontent:[],
showselectTime:false,
format:function(ensureDate){
return `${ensureDate}`
},
comnCode:'',
hsNo:'',
hsName:'',
hsPhone:'',
message:'',
showAlert:false,
show_1:false,
show2:false,
text_1:"",
useragent:''
}
},
beforeMount(){
this.show_1 = true;
if(this.$router.history.current.path == "/repair"){
document.title = "报事报修";
}
this.useragent = navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ? true : false;
console.log('this.useragent = ' + this.useragent)
let curTime = dateFormat(new Date(),'YYYY-MM-DD HH');
let curHour = dateFormat(new Date(),'HH');
this.ensureDate = curTime + ':00-' + curHour + ':59'
console.log(this.ensureDate)
this.minyear = new Date().getFullYear();
this.$http.get(global.host + 'users/personalCenter?phone=' + this.$router.history.current.query.phone +'&openid=' + this.$router.history.current.query.openid).then(function(res){
if(res.body.result){
console.log(res);
let data = res.body.result[0];
this.src = data.photoUrl;
this.houseinfo = data.comName + data.hsNo;
this.houseonwer = data.name + "("+ data.mainPhone + ")";
this.hsNo = data.hsNo;
this.hsName = data.hsName;
this.comnCode = data.comn_code;
this.hsPhone = data.mainPhone;
this.initRepairTypeList();
}
},function(err){
console.log(err);
})
},
methods:{
initRepairTypeList(){
this.$http.get(global.host + 'repair/findRepairTypeList?comnCode='+this.comnCode).then(function(res){
console.log(res);
for(let i = 0 ; i < res.body.priAreaList.length; i++){
this.perTag.push(res.body.priAreaList[i]);
this.perTagId.push(res.body.priAreaList[i].id)
this.perTagName.push(res.body.priAreaList[i].name)
}
for(let i = 0 ; i < res.body.pubAreaList.length; i++){
this.pubTag.push(res.body.pubAreaList[i]);
this.pubTagId.push(res.body.pubAreaList[i].id)
this.pubTagName.push(res.body.pubAreaList[i].name)
}

console.log(this.perTag)
this.show_1 = false;
},function(err){
console.log(err)
})
},
deleteImg(index){
this.filecontent.splice(index,1)
},
filteremoji(){
var ranges = [
'\ud83c[\udf00-\udfff]',
'\ud83d[\udc00-\ude4f]',
'\ud83d[\ude80-\udeff]',

];
this.info = this.info.replace(new RegExp(ranges.join('|'), 'g'), '');

},
onItemClick(index){
let size = document.getElementById('tag').children.length;
for(let i = 0 ; i < size ; i++){
if(document.getElementById('tag').children[i].classList.contains('weui-btn_primary')){
document.getElementById('tag').children[i].classList.remove('weui-btn_primary')
}
}
let sizeType = this.repair.length ;
for(let i = 0 ; i < sizeType ; i++){
this.repair.pop();
}
switch (index){
case 0:
this.showTime = true;
break;
case 1:
this.showTime = false;
break;
}
},
changeStype(index){
let classList = document.getElementById(index).classList;
if(classList.contains('weui-btn_primary')){
classList.remove('weui-btn_primary');
this.repair.splice(this.repair.indexOf(index),1)
}else{
classList.add('weui-btn_primary');
this.repair.push(index)
}
},
selectFile(){
let filehandler = document.getElementById('file')
if(filehandler.files){
let fileList = filehandler.files;
let self = this;
let size = this.filecontent.length;

for(let i = 0 ; i < (fileList.length > 3 ? 3 :fileList.length) ; i++){
var reader = new FileReader();
reader.readAsDataURL(fileList[i]);

reader.onload = function (event) {
var img = new Image;

let width = 680, //图像大小
quality = 0.8, //图像质量
canvas = document.createElement("canvas"),
drawer = canvas.getContext("2d");
img.src = this.result;
img.onload = function () {
canvas.width = width;
canvas.height = width * (img.height / img.width);
drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
let imgBase64 = canvas.toDataURL("image/jpeg", quality);
self.filecontent.push(imgBase64);
img.src="";
}
}

}
for(let j = 0 ; j < size ; j++){
this.filecontent.pop();
}
}
},
dianjiFile(ev){
var oEvent = ev || event;
if(!oEvent.isTrusted){
document.getElementById("file").click();
}

oEvent.cancelBubble = true;
oEvent.stopPropagation();
},
showTimeBox(){
this.showselectTime = !this.showselectTime;
},

selectTime(){
this.ensureDate = this.ensureDate + ' ' + this.ensureTime[0];
},

submitForm(){
this.filteremoji()
this.show_1 = true;
this.sbm = true














this.show_1 = true
if(this.repair.length < 1 ){
this.message ='请选择报修类型'
this.showAlert = true;
this.show_1 = false;
this.sbm = false
}else if(!this.info){
this.message ='请输入报修内容'
this.showAlert = true;
this.show_1 = false;
this.sbm = false
}else if(!this.ensureDate && this.showTime){
this.message ='请选择服务上门时间'
this.showAlert = true;
this.show_1 = false;
this.sbm = false
}else{
this.show1 = true;
this.show2 = true;
this.repairType = this.repair.join(',')
let sendDate = {};
sendDate.comnCode = this.comnCode;
sendDate.hsNo = this.hsNo;
sendDate.hsName = this.hsName;
sendDate.hsPhone = this.hsPhone;
sendDate.repairType = this.repairType;
sendDate.repairDesc = this.info;
sendDate.applyDate = this.ensureDate;
sendDate.images = this.filecontent;
sendDate.handleState  ='0';
this.$http.post(global.host + 'repair/submitrepair',sendDate).then(function(res){
console.log(res)
this.show1 = false;
this.show2 = false;
if(res.body.msgcode == '120'){
this.message = '报修信息提交失败'
this.showAlert = true;
this.show_1 = false;
this.sbm = false
}else{
this.message = '报修信息提交成功'
this.showAlert = true;
this.show_1 = false;

}
document.getElementById("btns").disabled = false;
},function(err){
console.log(err)
})
}
},

getIndex(arr,field){
for(let i = 0 ; i < arr.length ; i++){
if(arr[i] == field){
return i
}
}
},

hideAlert(){
if(this.message == '报修信息提交成功'){
let hsNos = this.hsNo;
this.sbm = false
this.$router.push({path:'/orderlist',query:{openid:this.$router.history.current.query.openid,phone:this.$router.history.current.query.phone,communityId:this.comnCode,hscodes:hsNos}})
}
},

changefocus(){
document.getElementById('file').click();

},
createObjectURL(object){
return (window.URL) ? window.URL.createObjectURL(object) : window.webkitURL.createObjectURL(object);
}
}
}



// WEBPACK FOOTER //
// ./src/components/repairComponents/repair.vue